import {
  CREATE_CLIENT_SUCCESS,
  FETCH_CLIENT_SUCCESS,
  GET_CLIENT_SUCCESS,
  SAVE_CLIENT_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_CLIENT_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_CLIENT_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_CLIENT_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_CLIENT_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }


    default:
      return state;
  }
}
